import gsap from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin';
import * as PIXI from 'pixi.js';
import ErrorBoundary from './components/ErrorBoundary';
import { useVersionLogging } from './lib/hooks/useVersionLogging';
import { AnimationLayout } from './lib/routing/AnimationLayout';
import { GameDataProvider } from './providers/GameDataProvider';
import { UIContextProvider } from './providers/UIContextProvider';
import { MainLayout } from './MainLayout';

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);

export const App = () => {
  useVersionLogging('Casp Game');

  return (
    <ErrorBoundary>
      <div>
        {/*
          Note that only the components rendered by <Outlet /> will change,
          any other component added here (e.g <Navbar />) will be static
        */}
        <UIContextProvider>
          <GameDataProvider>
            <MainLayout>
              <AnimationLayout />
            </MainLayout>
          </GameDataProvider>
        </UIContextProvider>
      </div>
    </ErrorBoundary>
  );
};

export default App;
